import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Managment } from 'src/app/interfaces/managment';
import { ManagmentService } from 'src/app/services/managment.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-add-edit-managment',
  templateUrl: './add-edit-managment.component.html',
  styleUrls: ['./add-edit-managment.component.css']
})
export class AddEditManagmentComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';

  constructor(private fb: FormBuilder,
    private _managmentService: ManagmentService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      state: [null, Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {

    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getManagment(this.id);
    }
  }

  getManagment(id: number) {
    this.loading = true;
    this._managmentService.getManagment(id).subscribe((data: Managment) => {
      this.loading = false;
      this.form.setValue({
        name: data.name,
        state: data.state
      })
    })
  }

  addManagment() {
    /*  console.log(this.form.value.name);
     console.log(this.form.get('name')?.value); */

    const managment: Managment = {
      name: this.form.value.name,
      state: this.form.value.state
    }
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
      console.log("Editado: "+ managment);
      managment.id = this.id;
      this._managmentService.updateManagment(this.id, managment).subscribe(() => {
        this.toastr.info(`La gestión ${managment.name} fue actualizada con exito`, 'Gestión actualizada');
        this.loading = false;
        this.router.navigate(['/managment']);
      })

    } else {
      // Es agregagar
      console.log("Agregado: "+ managment);
      this._managmentService.saveManagment(managment).subscribe(() => {
        this.toastr.success(`La gestión ${managment.name} fue registrada con exito`, 'Gestión registrada');
        this.loading = false;
        this.router.navigate(['/managment']);
      })
    }
  }
}
